export default __webpack_public_path__ + "static/media/worldSVG.9a20f021.svg";